/** @jsx jsx */

import { formatDateTime } from '@zapier/date';
import {
  Alert,
  Table,
  TableBody,
  TableHead,
  TableHeadHeading,
  TableRow,
  TableTd,
  TableTh,
  Text,
} from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import AuthorCell from './AuthorCell';
import Loading from './Loading';

const Styles = {
  hiddenBottomBorder: css`
    border-bottom-style: none !important;
  `,
  initialTextAlignment: css`
    text-align: initial;
  `,
};

type Props = {
  isLoading: boolean;
  isStaff: boolean;
  isTitleVisible: boolean;
  isVersionColumnVisible: boolean;
  logs: Array<unknown>;
};

function VersionHistory({
  isLoading,
  isStaff,
  isTitleVisible,
  isVersionColumnVisible,
  logs,
}: Props) {
  const isMoreInfoColumnVisible = logs?.some(({ message }) => message);

  return isLoading ? (
    <Loading
      isMoreInfoColumnVisible={isMoreInfoColumnVisible}
      isTitleVisible={isTitleVisible}
      isVersionColumnVisible={isVersionColumnVisible}
    />
  ) : logs?.length === 0 ? (
    <Alert>There aren’t any audit logs.</Alert>
  ) : (
    <Table>
      <TableHead>
        <TableRow>
          {isTitleVisible && (
            <th css={[Styles.hiddenBottomBorder, Styles.initialTextAlignment]}>
              <Text type="Title">History</Text>
            </th>
          )}
          <TableTh>
            <TableHeadHeading>Date</TableHeadHeading>
          </TableTh>
          <TableTh>
            <TableHeadHeading>Author</TableHeadHeading>
          </TableTh>
          <TableTh>
            <TableHeadHeading>Action</TableHeadHeading>
          </TableTh>
          {isVersionColumnVisible && (
            <TableTh>
              <TableHeadHeading>Version</TableHeadHeading>
            </TableTh>
          )}
          {isMoreInfoColumnVisible && (
            <TableTh>
              <TableHeadHeading>More Info</TableHeadHeading>
            </TableTh>
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {logs?.map(
          ({ action, customuser, date, id, message, version }, indexLog) => (
            <TableRow key={id}>
              {isTitleVisible && (
                <td
                  css={
                    indexLog === logs.length - 1
                      ? undefined
                      : Styles.hiddenBottomBorder
                  }
                />
              )}
              <TableTd>{formatDateTime(date, 'exhaustive')}</TableTd>
              <TableTd>
                <AuthorCell isStaff={isStaff} text={customuser} />
              </TableTd>
              <TableTd>{action}</TableTd>
              {isVersionColumnVisible && <TableTd>{version || ''}</TableTd>}
              {isMoreInfoColumnVisible && <TableTd>{message}</TableTd>}
            </TableRow>
          )
        )}
      </TableBody>
    </Table>
  );
}

export default VersionHistory;
